// localStorage utility functions for flashcard memory

export const getStorageKey = (vocabularyId) => {
  return `flashcards_memory_${vocabularyId}`;
};

export const getMemorizedCards = (vocabularyId) => {
  try {
    const stored = localStorage.getItem(getStorageKey(vocabularyId));
    return stored ? new Set(JSON.parse(stored)) : new Set();
  } catch (error) {
    console.error('Error reading memorized cards from localStorage:', error);
    return new Set();
  }
};

export const addMemorizedCard = (vocabularyId, cardId) => {
  try {
    const memorized = getMemorizedCards(vocabularyId);
    memorized.add(cardId);
    localStorage.setItem(getStorageKey(vocabularyId), JSON.stringify([...memorized]));
    return memorized;
  } catch (error) {
    console.error('Error saving memorized card to localStorage:', error);
    return getMemorizedCards(vocabularyId);
  }
};

export const removeMemorizedCard = (vocabularyId, cardId) => {
  try {
    const memorized = getMemorizedCards(vocabularyId);
    memorized.delete(cardId);
    localStorage.setItem(getStorageKey(vocabularyId), JSON.stringify([...memorized]));
    return memorized;
  } catch (error) {
    console.error('Error removing memorized card from localStorage:', error);
    return getMemorizedCards(vocabularyId);
  }
};

export const resetMemorizedCards = (vocabularyId) => {
  try {
    localStorage.removeItem(getStorageKey(vocabularyId));
    return new Set();
  } catch (error) {
    console.error('Error resetting memorized cards:', error);
    return new Set();
  }
};

const CURRENT_FOLDER_KEY = 'flashcards_current_folder';

export const getCurrentFolder = () => {
  try {
    return localStorage.getItem(CURRENT_FOLDER_KEY);
  } catch (error) {
    console.error('Error reading current folder from localStorage:', error);
    return null;
  }
};

export const setCurrentFolder = (folder) => {
  try {
    if (folder) {
      localStorage.setItem(CURRENT_FOLDER_KEY, folder);
    } else {
      localStorage.removeItem(CURRENT_FOLDER_KEY);
    }
  } catch (error) {
    console.error('Error saving current folder to localStorage:', error);
  }
};

export const getMemoryStats = (vocabularyId, totalCards) => {
  const memorized = getMemorizedCards(vocabularyId);
  return {
    memorizedCount: memorized.size,
    remainingCount: totalCards - memorized.size,
    totalCount: totalCards,
    completionPercentage: totalCards > 0 ? Math.round((memorized.size / totalCards) * 100) : 0
  };
};